import { useState } from "react";

export const useHandleOnBoardingStates = () => {
    const [selectedOnboardingOptions, setSelectedOnboardingOptions] = useState({
        selectedPortfolio: { id: "", label: "", value: "" },
        selectedPlatform: { id: "", label: "", value: "" },
        selectedProduct: { id: "", label: "", value: "" },
        selectedApp: { id: "", label: "", value: "" },
        mvcVulnerabilityRelated: [],
      });
    
      const [macAppId, setMacAppId] = useState("")
      const [onboardingOptions, setOnboardingOptions] = useState({
        portfolio: [],
        platform: [],
        product: [],
        app: [],
      });
    
      const [loadingStates, setLoadingStates] = useState({
        portfolio: false,
        platform: false,
        product: false,
        app: false,
        macAppId: false,
      });
    
      const [errorStates, setErrorStates] = useState({
        portfolio: {
          isError: false,
          errorMessage: "",
        },
        platform: {
          isError: false,
          errorMessage: "",
        },
        product: {
          isError: false,
          errorMessage: "",
        },
        app: {
          isError: false,
          errorMessage: "",
        },

        macAppId:{
          isError: false,
          errorMessage: "",
        
        },

        mvcVulnerabilityRelated: {
          isError: false,
          errorMessage: "",
        },
      });

      const [appOptionsAvailable, setAppOptionsAvailable] = useState(false)
    return {
        selectedOnboardingOptions,
        onboardingOptions,
        loadingStates,
        errorStates,
        setSelectedOnboardingOptions,
        setLoadingStates,
        setErrorStates,
        setOnboardingOptions,
        macAppId,
         setMacAppId,
         appOptionsAvailable,
          setAppOptionsAvailable
    }
}